import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import RegisterForm from '../components/RegisterForm'
import { listRegion } from '../../datas/DatasActions'
import { registerForm } from '../../user/UserActions'
import { asyncValidateUsernameNotExists  } from '../../utils/forms/validators'


const mapStateToProps = (state) => {
    return {
  		regions : state.datas.regions,
        user : state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        listRegion: () => {
            return dispatch(listRegion())
        }
    }
};

const validate = values => {
  const errors = {};

  if (values.password !== values.confirm_password) {
    errors.confirm_password = 'Les mots de passe ne correspondent pas'
  }

  return errors
};

const config = {
    form: 'RegisterForm',
    onSubmit: (values, dispatch, props) => {
       return dispatch(registerForm(values))
    },
    asyncValidate: asyncValidateUsernameNotExists,
    asyncBlurFields: ['username','phone'],
    validate
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(RegisterForm))



// WEBPACK FOOTER //
// ./src/user/containers/RegisterFormContainer.js